module.exports = markdownLineEnding;

function markdownLineEnding(code) {
  return code < -2;
}